import axios from "axios";
import { useNavigate } from "react-router-dom";



// GET CALLS
export async function getData(url,accessToken) {
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201 || response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      if(error.response.data.status===401){
        localStorage.removeItem('userDetails')
        window.location.href= "/login"
      }
      // console.log("ERROR: ", error.response.data.status)
      throw error;
    }
  } 
  export async function getData1(url) {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201 || response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  }
  // POST CALLS
  export async function postData(url,accessToken, formData) {
    try {
      const response = await axios.post(url,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      if(error.response.data.status===401){
        localStorage.removeItem('userDetails')
        window.location.href= "/login"
      }
      if (error.response) {
       
        return error.response.data;
      }
    }
  }
  export async function postDataJSON(url,accessToken, formData) {
    try {
      const response = await axios.post(url,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {

      if(error.response.data.status===401){
        localStorage.removeItem('userDetails')
        window.location.href= "/login"
      }

      if (error.response) {
      
       
        return error.response.data;
      }
    }
  }
  export async function loginData(url, formData) {
    try {
      const response = await axios.post(url,formData);
      return response.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }
  export async function postData1(url, formData) {
    try {
      const response = await axios.post(url,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;

    } catch (error) {
      if (error.response) {
        // console.log("API error response:", error.response.data);
        return error.response.data;
      }
    }
  }
  // PUT CALLS
  export async function putData(url,accessToken, formData) {
    try {
        const response = await axios.put(url, formData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
      if(error.response.data.status===401){
        localStorage.removeItem('userDetails')
        window.location.href= "/login"
      }
        if (error.response) {
         
            return error.response.data;
        }
    }
}
export async function putDataJson(url,accessToken, formData) {
  try {
      const response = await axios.put(url, formData, {
          headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
          },
      });
      return response.data;
  } catch (error) {
    if(error.response.data.status===401){
      localStorage.removeItem('userDetails')
      window.location.href= "/login"
    }
      if (error.response) {
       
          return error.response.data;
      }
  }
}
// DELETE CALL
export async function deleteData(url, accessToken, formData) {
  try {
      const response = await axios.delete(url, {
          headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'multipart/form-data',
          },
          data: formData
      });
      return response.data;
  } catch (error) {
    if(error.response.data.status===401){
      localStorage.removeItem('userDetails')
      window.location.href= "/login"
    }
      if (error.response) {
          // console.log('API error response:', error.response.data);
          return error.response.data;
      }
  }
}